import styled from "../../../styled";
import { CardHeader } from "../../Common/Card";

export const StyledHeader = styled(({ ...props }) => <CardHeader {...props} />)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
